__turbopack_context__.v({
  "picture": "picture-component-module-scss-module__XPhf3q__picture",
  "picture__wrapper": "picture-component-module-scss-module__XPhf3q__picture__wrapper",
});
